/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-all-contractor-contacts');

    $datatable.DataTable({
        "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
	    "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": helper.getOrigin() + "/api/contractors/contacts",
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            {data: 'name', name: 'name'},
	        {data: 'company', name: 'company'},
            {data: 'email', name: 'userEmail'},
            {data: 'phone', name: 'userPhoneNumber'},
            {data: 'department', name: 'department'},
            {data: 'job_title', name: 'job_title'},
	        {data: 'color', name: 'color'},
	        {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ]
    });

	$('.js-ticket-go-to-contractor-contact-calendar').on('change', function(e) {

		var contactId = $(this).val();

		if(contactId > 0){
			window.location.href = helper.getOrigin() + "/contractors/contacts/" + contactId + "/calendar";
		}
	});

});
